if (!customElements.get('product-modal')) {
  const style = document.createElement('style');
  style.textContent = `
  product-modal.core-lightbox{position:fixed!important;inset:0!important;width:100%!important;height:100%!important;height:100dvh!important;z-index:10000;background:#fff;opacity:0;transition:opacity 150ms ease}
  product-modal.core-lightbox[open]{opacity:1;visibility:visible}
  product-modal.core-lightbox.core-closing{opacity:0}
  .core-lightbox .product-media-modal__dialog{position:absolute!important;inset:0!important;min-height:0!important;height:100%!important;background:#fff;color:#111}
  .core-lightbox .product-media-modal__content{position:absolute!important;inset:0!important;box-sizing:border-box!important;width:100%!important;height:100%!important;min-height:0!important;max-width:none!important;padding:0!important;margin:0!important;overflow:hidden!important;touch-action:none;overscroll-behavior:contain}
  .core-lightbox .product-media-modal__content>img{display:none!important;border:0!important;border-radius:0!important;box-shadow:none!important}
  .core-lightbox .product-media-modal__content>img.active{display:block!important;position:absolute!important;left:50%!important;top:50%!important;width:calc(100% - 100px)!important;height:calc(100% - 140px - env(safe-area-inset-top) - env(safe-area-inset-bottom))!important;max-width:none!important;max-height:none!important;min-width:0!important;object-fit:contain!important;transform:translate(-50%,-50%) translate(var(--core-pan-x,0px),var(--core-pan-y,0px)) scale(var(--core-zoom,1));transform-origin:center;user-select:none;-webkit-user-drag:none}
  .core-lightbox .product-media-modal__toggle,.core-lightbox-control{position:absolute!important;z-index:3!important;display:grid;place-items:center;width:44px!important;height:44px!important;min-width:44px;min-height:44px;border:1px solid #d5d5d5!important;border-radius:12px!important;background:#fff!important;color:#111!important;box-shadow:none!important;cursor:pointer;touch-action:manipulation;font:inherit;font-size:22px;padding:8px}
  .core-lightbox .product-media-modal__toggle{top:calc(12px + env(safe-area-inset-top))!important;right:calc(12px + env(safe-area-inset-right))!important}
  .core-lightbox-prev{left:12px;top:calc(50% - 22px)}.core-lightbox-next{right:12px;top:calc(50% - 22px)}
  .core-lightbox-zoom{bottom:calc(12px + env(safe-area-inset-bottom));right:calc(12px + env(safe-area-inset-right));font-size:14px}
  .core-lightbox-count{position:absolute;bottom:calc(23px + env(safe-area-inset-bottom));left:50%;transform:translateX(-50%);z-index:3;font-size:13px;line-height:1.3;color:#111}
  .core-lightbox-status{position:absolute;z-index:2;left:50%;top:50%;transform:translate(-50%,-50%);padding:12px;border-radius:12px;background:#fff;font-size:13px;text-align:center;color:#111}
  .core-lightbox-status[hidden]{display:none}.core-lightbox-control:focus-visible,.core-lightbox .product-media-modal__toggle:focus-visible{outline:2px solid #111;outline-offset:3px}
  .core-lightbox .product-media-modal__content:focus-visible{outline:none}
  @media(max-width:749px){.core-lightbox .product-media-modal__content>img.active{width:calc(100% - 24px)!important}.core-lightbox-prev,.core-lightbox-next{top:auto;bottom:calc(12px + env(safe-area-inset-bottom))}.core-lightbox-next{right:66px}.core-lightbox-count{left:77px}}
  @media(prefers-reduced-motion:reduce){product-modal.core-lightbox{transition:none!important}}
  `;
  document.head.append(style);
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.points = new Map();
      this.scale = 1; this.panX = 0; this.panY = 0;
      this.addEventListener('pointerup', event => {
        if (!this.classList.contains('core-lightbox')) return;
        this.finishPointer(event);
        event.stopImmediatePropagation();
      }, true);
      this.addEventListener('keydown', event => {
        if (!this.hasAttribute('open')) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault(); this.go(event.key === 'ArrowLeft' ? -1 : 1);
        }
      });
    }
    setup() {
      if (this.ready) return;
      this.ready = true;
      this.classList.add('core-lightbox');
      this.stage = this.querySelector('[role="document"]');
      this.dialog = this.querySelector('[role="dialog"]');
      this.dialog.setAttribute('aria-label', 'Product image viewer');
      this.closeButton = this.querySelector('[id^="ModalClose-"]');
      const button = (name, label, text, action) => {
        const node = document.createElement('button');
        node.type = 'button'; node.className = 'core-lightbox-control core-lightbox-' + name;
        node.setAttribute('aria-label', label); node.textContent = text;
        node.addEventListener('click', action); this.dialog.append(node); return node;
      };
      this.prev = button('prev', 'Previous image', '‹', () => this.go(-1));
      this.next = button('next', 'Next image', '›', () => this.go(1));
      this.zoomButton = button('zoom', 'Zoom in', '+', () => this.zoom(this.scale > 1 ? 1 : 2));
      this.counter = document.createElement('span'); this.counter.className = 'core-lightbox-count';
      this.counter.setAttribute('aria-live', 'polite'); this.counter.setAttribute('aria-atomic', 'true');
      this.status = document.createElement('div'); this.status.className = 'core-lightbox-status'; this.status.setAttribute('role', 'status');
      this.dialog.append(this.counter, this.status);
      this.stage.addEventListener('pointerdown', event => this.beginPointer(event));
      this.stage.addEventListener('pointermove', event => this.movePointer(event));
      this.stage.addEventListener('pointercancel', event => { this.points.delete(event.pointerId); this.gesture = null; });
      this.stage.addEventListener('dblclick', event => { if (Date.now() - (this.lastTouchTime || 0) > 500) this.zoom(this.scale > 1 ? 1 : 2); });
      this.stage.addEventListener('dragstart', event => event.preventDefault());
      this.addEventListener('touchmove', event => event.preventDefault(), {passive:false});
      this.dialog.addEventListener('click', event => { if (event.target === this.status.querySelector('button')) this.load(this.images[this.index], true); });
    }
    show(opener) {
      clearTimeout(this.closeTimer);
      this.setup(); this.classList.remove('core-closing');
      this.images = Array.from(this.stage.children).filter(node => node.tagName === 'IMG');
      if (!this.images.length) { super.show(opener); return; }
      if (!this.hasAttribute('open')) {
        this.savedScroll = {x:window.scrollX,y:window.scrollY};
        this.savedBody = document.body.getAttribute('style');
        this.sourceGallery = opener.closest('media-gallery');
        this.dots = this.sourceGallery?.querySelector('core-gallery-dots');
        if (this.dots) { this.wasPaused = this.dots.paused; this.dots.paused = true; clearTimeout(this.dots.timer); }
      }
      super.show(opener);
      document.body.style.position = 'fixed'; document.body.style.top = -this.savedScroll.y + 'px';
      document.body.style.left = -this.savedScroll.x + 'px'; document.body.style.width = '100%';
      const id = opener.getAttribute('data-media-id');
      this.index = Math.max(0,this.images.findIndex(image => image.dataset.mediaId === id));
      this.render(); this.closeButton.focus({preventScroll:true});
    }
    hide() {
      if (!this.hasAttribute('open') || this.classList.contains('core-closing')) return;
      this.classList.add('core-closing');
      const finish = () => {
        super.hide(); this.classList.remove('core-closing'); this.points.clear();
        if (this.savedBody === null) document.body.removeAttribute('style');
        else if (this.savedBody !== undefined) document.body.setAttribute('style', this.savedBody);
        if (this.savedScroll) window.scrollTo({left:this.savedScroll.x,top:this.savedScroll.y,behavior:'instant'});
        this.openedBy?.focus({preventScroll:true});
        if (this.dots) this.dots.paused = this.wasPaused;
      };
      if (matchMedia('(prefers-reduced-motion: reduce)').matches) finish();
      else this.closeTimer = setTimeout(finish,150);
    }
    source(image) {
      const raw = image.dataset.coreFullSrc || image.dataset.coreZoomSrc || image.getAttribute('src');
      if (!raw) return null;
      const url = new URL(raw, location.href);
      url.searchParams.set('width', String(Math.min(3000,Math.max(1600,Math.ceil(Math.max(innerWidth,innerHeight) * (devicePixelRatio || 1) * 2)))));
      return url.href;
    }
    load(image, retry = false) {
      const source = this.source(image);
      if (!source) { this.error(image); return; }
      if (!image.dataset.coreFullSrc) image.dataset.coreFullSrc = image.dataset.coreZoomSrc || image.getAttribute('src');
      if (!retry && image.dataset.coreLoaded === source && image.complete && image.naturalWidth) { this.status.hidden = true; return; }
      if (image === this.images[this.index]) { this.status.hidden = false; this.status.textContent = 'Loading image…'; }
      image.onload = () => { image.dataset.coreLoaded = source; if (image === this.images[this.index]) { this.status.hidden = true; this.paint(); } };
      image.onerror = () => this.error(image);
      image.removeAttribute('srcset'); image.removeAttribute('sizes'); image.loading = 'eager'; image.decoding = 'async';
      image.src = source;
      if (image.complete && image.naturalWidth) image.onload();
    }
    error(image) {
      if (image !== this.images[this.index]) return;
      this.status.hidden = false; this.status.replaceChildren(document.createTextNode('This image could not load. '));
      const retry = document.createElement('button'); retry.type = 'button'; retry.textContent = 'Try again';
      retry.style.cssText = 'border:1px solid #111;border-radius:8px;background:#fff;color:#111;min-height:44px;padding:8px'; this.status.append(retry);
    }
    render() {
      this.points.clear(); this.gesture = null;
      this.images.forEach((image,index) => { image.classList.toggle('active',index === this.index); image.setAttribute('aria-hidden',String(index !== this.index)); image.draggable = false; });
      this.zoom(1);
      this.counter.textContent = (this.index + 1) + ' / ' + this.images.length;
      this.load(this.images[this.index]);
      for (const offset of [-1,1]) {
        const image = this.images[(this.index + offset + this.images.length) % this.images.length];
        if (image !== this.images[this.index]) { const src = this.source(image); if (src) { const preload = new Image(); preload.src = src; } }
      }
    }
    go(delta) { this.index = (this.index + delta + this.images.length) % this.images.length; this.render(); }
    zoom(scale) {
      this.scale = Math.max(1,Math.min(4,scale));
      if (this.scale === 1) { this.panX = 0; this.panY = 0; }
      this.zoomButton?.setAttribute('aria-label',this.scale > 1 ? 'Zoom out' : 'Zoom in');
      if (this.zoomButton) this.zoomButton.textContent = this.scale > 1 ? '−' : '+';
      this.paint();
    }
    paint() {
      const image = this.images?.[this.index]; if (!image) return;
      const w = image.clientWidth, h = image.clientHeight;
      if (!w || !h) return;
      if (!Number.isFinite(this.panX)) this.panX = 0;
      if (!Number.isFinite(this.panY)) this.panY = 0;
      const fit = Math.min(w / (image.naturalWidth || w),h / (image.naturalHeight || h));
      const limitX = Math.max(0,((image.naturalWidth || w) * fit * this.scale - w) / 2);
      const limitY = Math.max(0,((image.naturalHeight || h) * fit * this.scale - h) / 2);
      this.panX = Math.max(-limitX,Math.min(limitX,this.panX)); this.panY = Math.max(-limitY,Math.min(limitY,this.panY));
      image.style.setProperty('--core-zoom',this.scale); image.style.setProperty('--core-pan-x',this.panX + 'px'); image.style.setProperty('--core-pan-y',this.panY + 'px');
    }
    beginPointer(event) {
      if (event.button && event.pointerType === 'mouse') return;
      if (event.pointerType === 'touch') this.lastTouchTime = Date.now();
      this.stage.setPointerCapture(event.pointerId);
      this.points.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if (this.points.size === 1) this.gesture = {x:event.clientX,y:event.clientY,panX:this.panX,panY:this.panY,time:Date.now(),pinched:false};
      if (this.points.size === 2) {
        const [a,b] = this.points.values(); this.gesture.pinched = true;
        this.pinch = {distance:Math.hypot(a.x-b.x,a.y-b.y),scale:this.scale,x:(a.x+b.x)/2,y:(a.y+b.y)/2,panX:this.panX,panY:this.panY};
      }
    }
    movePointer(event) {
      if (!this.points.has(event.pointerId) || !this.gesture) return;
      event.preventDefault(); this.points.set(event.pointerId,{x:event.clientX,y:event.clientY});
      if (this.points.size === 2 && this.pinch) {
        const [a,b] = this.points.values(); this.panX = this.pinch.panX + (a.x+b.x)/2-this.pinch.x; this.panY = this.pinch.panY + (a.y+b.y)/2-this.pinch.y;
        this.zoom(this.pinch.scale * Math.hypot(a.x-b.x,a.y-b.y) / Math.max(1,this.pinch.distance));
      } else if (this.scale > 1 && !this.gesture.pinched) {
        this.panX = this.gesture.panX + event.clientX-this.gesture.x; this.panY = this.gesture.panY + event.clientY-this.gesture.y; this.paint();
      }
    }
    finishPointer(event) {
      if (!this.points.has(event.pointerId)) return;
      this.points.delete(event.pointerId);
      if (this.points.size || !this.gesture) return;
      const gesture = this.gesture; this.gesture = null;
      if (gesture.pinched) return;
      const dx = event.clientX-gesture.x, dy = event.clientY-gesture.y;
      if (this.scale === 1 && Math.abs(dx) > 45 && Math.abs(dx) > Math.abs(dy) * 1.3) { this.go(dx < 0 ? 1 : -1); return; }
      if (event.pointerType === 'touch' && Math.hypot(dx,dy) < 12 && Date.now()-gesture.time < 300) {
        if (this.lastTap && Date.now()-this.lastTap.time < 300 && Math.hypot(event.clientX-this.lastTap.x,event.clientY-this.lastTap.y) < 30) { this.zoom(this.scale > 1 ? 1 : 2); this.lastTap = null; }
        else this.lastTap = {time:Date.now(),x:event.clientX,y:event.clientY};
      }
    }
  });
}
